// This file is auto-generated at build time
export const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION || 'dev';
